import { combineReducers } from '@ngrx/store';
import { ParameterType } from '../../_generated';
import { ParameterValues } from '../../data-entry/models/parameters.type';
import { RequestStatus } from '../actionstypes/request-status/request-status.actiontype';
import dataTypeReducer from './data-type/data-type.reducer';
import { RootEmissionPoints, emissionPointsRootReducer } from './emission-points/emission-points.root.reducer';
import { RootEntryCycles, entryCyclesRootReducer } from './entry-cycles/entry-cycles.root.reducer';
import fileImportReducer, { FileImportState } from './file-import/file-import.reducer';
import parameterValuesReducer from './parameter-values/parameter-values.reducer';
import { RootParameters } from './parameters/parameters.root.reducer';
import emissionPointIdReducer from './selected-id/emission-point-id.reducer';
import entryCycleIdReducer from './selected-id/entry-cycle-id.reducer';
import parameterIdReducer from './selected-id/parameter-id.reducer';
import shopIdReducer from './selected-id/shop-id.reducer';
import siteIdReducer from './selected-id/site-id.reducer';
import statusFilterReducer from './selected-id/status-filter.reducer';
import toolIdReducer from './selected-id/tool-id.reducer';
import { RootShops, shopsRootReducer } from './shops/shops.root.reducer';
import { RootSites, sitesRootReducer } from './sites/sites.root.reducer';
import { RootTools, toolsRootReducer } from './tools/tools.root.reducer';

export interface DataEntryStore {
  dataType: ParameterType;
  sites: RootSites;
  shops: RootShops;
  tools: RootTools;
  emissionPoints: RootEmissionPoints;
  entryCycles: RootEntryCycles;
  parameters: RootParameters;
  selectedSiteId: number;
  selectedShopId: number;
  selectedToolId: number;
  selectedEmissionPointId: number;
  selectedEntryCycleId: number;
  selectedStatusFilter: string;
  selectedParameterIds: Map<ParameterType, number[]>;
  parameterValues: ParameterValues;
  fileImport: FileImportState;
}

const requestStatus: RequestStatus = {
  isLoaded: false,
  isError: false,
  error: null,
};

const rootSites: RootSites = {
  requestStatus: requestStatus,
  data: [],
};

const rootShops: RootShops = {
  requestStatus: requestStatus,
  data: [],
};

const rootTools: RootTools = {
  requestStatus: requestStatus,
  data: [],
};

const rootEmissionPoints: RootEmissionPoints = {
  requestStatus: requestStatus,
  data: [],
};

const rootEntryCycles: RootEntryCycles = {
  requestStatus: requestStatus,
  data: [],
};

const rootParameters: RootParameters = {
  requestStatus: requestStatus,
  data: [],
};

export const initialState: DataEntryStore = {
  dataType: ParameterType.air,
  sites: rootSites,
  shops: rootShops,
  tools: rootTools,
  emissionPoints: rootEmissionPoints,
  entryCycles: rootEntryCycles,
  parameters: rootParameters,
  selectedSiteId: -1,
  selectedShopId: -1,
  selectedToolId: -1,
  selectedEmissionPointId: -1,
  selectedEntryCycleId: -1,
  selectedStatusFilter: '',
  selectedParameterIds: new Map(),
  parameterValues: {},
  fileImport: {
    uploadReport: null,
  },
};

export const dataEntryReducers = combineReducers(
  {
    dataType: dataTypeReducer,
    sites: sitesRootReducer,
    shops: shopsRootReducer,
    tools: toolsRootReducer,
    emissionPoints: emissionPointsRootReducer,
    entryCycles: entryCyclesRootReducer,
    selectedSiteId: siteIdReducer,
    selectedShopId: shopIdReducer,
    selectedToolId: toolIdReducer,
    selectedEmissionPointId: emissionPointIdReducer,
    selectedEntryCycleId: entryCycleIdReducer,
    selectedStatusFilter: statusFilterReducer,
    selectedParameterIds: parameterIdReducer,
    parameterValues: parameterValuesReducer,
    fileImport: fileImportReducer,
  },
  initialState,
);
